import React, { forwardRef, useState, memo, useEffect, useCallback, useRef } from 'react';
import PropTypes from 'prop-types';
import MuteButton from './MuteButton';
import Title from './Title';
import { ClirnetIconLogo } from '../../../icons/menuIconComponents';
import {
  BackwardIcon,
  ForwardIcon,
  FullScreenIcon,
  MiniizeIcon,
  NextIcon,
  PauseIcon,
  PlayIcon,
  PrevIcon,
  SettingsIcon
} from '../components';
import { InVideoBannerCard } from '../../../banner';
import CtaCard from './CtaCard';
import SkipButton from './SkipButton';
import { isIOS, isMobile } from 'react-device-detect';
import ShareCard from './ShareCard';
import InteractiveSpq from './InteractiveSpq';
import LazyImage from '../../LazyImage';
import IncomingCountDown from './IncomingCountDown';

const VIDEO_TYPE_ADS = 'ads';

const VIDEO_TYPE_MAIN = 'content';
const VIDEO_TYPE_SPQ = 'spq';

const Controls = forwardRef(
  (
    {
      onMobileOpenSettings,
      isLive = false,
      onSeek,
      onSeekMouseDown,
      onSeekMouseUp,
      currentTime,
      duration,
      onRewind,
      onPlayPause,
      onFastForward,
      playing,
      played,
      elapsedTime,
      totalDuration,
      onMute,
      muted,
      onVolumeSeekDown,
      onChangeDispayFormat,
      playbackRate,
      onPlaybackRateChange,
      onToggleFullScreen,
      volume,
      onContainerClick,
      onVolumeChange,
      onBookmark,
      isInFullScreen,
      videoHeight,
      isBuffering,
      onSettingsClick,
      isSettingsOpen,
      showSkipButton,
      videoType,
      title,
      deeplink,
      videoLoaded,
      adsData,
      adsIndex,
      onBannerClick,
      onSkipClick,
      onNextClick,
      onPrevClick,
      isError,
      playlist = [],
      playingIndex,
      controlsVisibility,
      onQuizStart,
      onQuizEnd,
      page_name,
      page_id,
      onCommingCountEnd,
      incommingCountDown
    },
    ref
  ) => {
    // const classes = useStyles();
    const [isSettingsExpanded, setIsSettingsExpanded] = useState(false);
    const [openedSetting, setOpenedSetting] = useState('');
    const [toogleInfo, setToogleInfo] = useState(false);
    const [isSeeking, setIsSeeking] = useState(false);
    const [iconAnimation, setIconAnimation] = useState(false);

    const [forwardAnimation, setForwardAnimation] = useState(false);
    const [backwardAnimation, setBackwardAnimation] = useState(false);
    const [curentDuration, setCurentDuration] = useState(0);
    const [currentVideoType, setCurrentVideoType] = useState(videoType);
    const [skipButton, setSkipButton] = useState(showSkipButton);
    const [isLoadingFirstTime, setIsLoadedFirstTime] = useState(true);
    const [showVolume, setShowVolume] = useState(false);
    // const [countDownBtn, setCountDownButton] = useState(incommingCountDown);
    const wrapperRef = useRef(null);
    const onOpenSettings = () => {
      if (isMobile) {
        onMobileOpenSettings();
      } else {
        isSettingsExpanded && setOpenedSetting('');
        setIsSettingsExpanded((prev) => !prev);
        onSettingsClick(isSettingsExpanded);
      }
    };

    useEffect(() => {
      function handleClickOutside(event) {
        if (
          isSettingsExpanded &&
          wrapperRef.current &&
          !wrapperRef.current.contains(event.target)
        ) {
          onOpenSettings();
        }
      }
      // Bind the event listener
      document.addEventListener('mousedown', handleClickOutside);
      return () => {
        // Unbind the event listener on clean up
        document.removeEventListener('mousedown', handleClickOutside);
      };
    }, [wrapperRef, isSettingsExpanded]);

    useEffect(() => {
      // setCountDownButton(incommingCountDown);
      console.log('in coming count down', incommingCountDown);
    }, [incommingCountDown]);

    useEffect(() => {
      setIsLoadedFirstTime(false);
      return () => {
        setIsLoadedFirstTime(true);
        setSkipButton(false);
      };
    }, []);

    useEffect(() => {
      setIsSettingsExpanded(isSettingsOpen);
    }, [isSettingsOpen]);

    useEffect(() => {
      // console.log('icon state chaneg', iconAnimation);
      if (iconAnimation) {
        setTimeout(() => {
          setIconAnimation(false);
        }, 500);
      }
    }, [iconAnimation]);

    useEffect(() => {
      if (forwardAnimation) {
        setTimeout(() => {
          setForwardAnimation(false);
        }, 600);
      }
    }, [forwardAnimation]);

    useEffect(() => {
      if (backwardAnimation) {
        setTimeout(() => {
          setBackwardAnimation(false);
        }, 600);
      }
    }, [backwardAnimation]);

    useEffect(() => {
      if (videoType == VIDEO_TYPE_MAIN) {
        setIconAnimation(!iconAnimation);
      }
    }, [playing]);

    useEffect(() => {
      setCurentDuration(currentTime);
    }, [currentTime]);

    // useEffect(() => {
    //   setTotalVideoDuration(videoDuration);
    // }, [videoDuration]);

    useEffect(() => {
      setCurrentVideoType(videoType);
    }, [videoType]);

    useEffect(() => {
      setSkipButton(showSkipButton);
    }, [showSkipButton]);

    const onSelectSettings = (type) => {
      setOpenedSetting(type);
    };

    const onToogleView = useCallback(() => {
      // setIsBannrExpanded(!isBannrExpanded);
    }, []);

    const onInfoBtnClick = () => {
      setToogleInfo(!toogleInfo);
    };

    // const btnPressHandler = useCallback(
    //   (event) => {
    //     switch (event.keyCode) {
    //       case 32: //space bar
    //         //console.log('space bar clicked' + event.keyCode);
    //         event.preventDefault();
    //         if (playing) {
    //           setvideoPlay(false);
    //         } else {
    //           setvideoPlay(true);
    //         }
    //         break;
    //       case 37: //left arrow
    //         // setvideoPlay(!videoPlay);
    //         break;
    //       case 39: //right arrow
    //         // setvideoPlay(!videoPlay);
    //         break;
    //       default:
    //         break;
    //     }
    //   },
    //   [playing]
    // );

    const onPlayBtnClick = () => {
      console.log('play btn clcic');
      setIconAnimation(!iconAnimation);
      onPlayPause();
    };

    function onBackwardClick(e) {
      // switch (e.detail) {
      //   case 1:
      //     break;
      //   case 2:
      setBackwardAnimation(true);
      onRewind();

      //     break;

      //   default:
      //     return;
      // }
      console.log('in double click back', e.target, e.detail);
    }

    function onForwardClick(e) {
      // switch (e.detail) {
      //   case 1:
      //     break;
      //   case 2:
      setForwardAnimation(true);
      onFastForward();
      //     break;

      //   default:
      //     break;
      // }
      console.log('in double click forward', e.target, e.detail);
    }

    const onSeekChange = () => {
      let seekTimer = '';
      if (!isSeeking) {
        setIsSeeking(true);
      }
      seekTimer = setTimeout(() => {
        setIsSeeking(false);
      }, 1000);
    };

    const onTapToUnMute = () => {
      if (isLoadingFirstTime) {
        setIsLoadedFirstTime(false);
      }
      onMute();
    };

    const quizEnd = () => {
      console.log('quiz end on controls component ');
      onQuizEnd();
    };
    const quizStart = () => {
      console.log('quiz start on controls component ');
      onQuizStart();
    };

    const onSkip = () => {
      console.log('on skip click');
      onSkipClick();
    };

    const onCountEnd = () => {
      console.log('incomming count down end');
      onCommingCountEnd();
    };

    const onCtaBtnClick = useCallback(() => {
      console.log('cta btn click in controls component ');
      if (onBannerClick) {
        onBannerClick(adsData, adsIndex);
      }
    }, [adsData, adsIndex, onBannerClick]);

    const playedPercentage =
      curentDuration > 0 || duration > 0 ? (curentDuration * 100) / duration : 0;
    const videoLoadedPercentage =
      videoLoaded > 0 || duration > 0 ? (videoLoaded * 100) / duration : 0;

    function useOutsideAlerter(ref) {
      useEffect(() => {
        function handleClickOutside(event) {
          if (ref.current && !ref.current.contains(event.target)) {
            setIsSettingsExpanded(false);
          }
        }
        // Bind the event listener
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
          // Unbind the event listener on clean up
          document.removeEventListener('mousedown', handleClickOutside);
        };
      }, [ref]);
    }
    return (
      <div
        // ref={ref}
        style={{ height: '100%' }}
        //  style={{ height: videoHeight }}
        className="clr_player__controlsComponent"
      >
        <>
          <div
            className={'clr_player__overlay'}
            ref={ref}
            style={!controlsVisibility ? { opacity: 0 } : { opacity: 1 }}
          ></div>
          {isError && (
            <div className="clr_player__messageArea">
              <div className="clr_player__icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  viewBox="0 0 16 16"
                >
                  <path d="M6.95.435c.58-.58 1.52-.58 2.1 0l6.515 6.516c.58.58.58 1.519 0 2.098L9.05 15.565c-.58.58-1.519.58-2.098 0L.435 9.05a1.482 1.482 0 0 1 0-2.098L6.95.435zm1.4.7a.495.495 0 0 0-.7 0L1.134 7.65a.495.495 0 0 0 0 .7l6.516 6.516a.495.495 0 0 0 .7 0l6.516-6.516a.495.495 0 0 0 0-.7L8.35 1.134z" />
                  <path d="M7.002 11a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 4.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 4.995z" />
                </svg>

                {/* <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  viewBox="0 0 16 16"
                >
                  <path d="M10.706 3.294A12.545 12.545 0 0 0 8 3C5.259 3 2.723 3.882.663 5.379a.485.485 0 0 0-.048.736.518.518 0 0 0 .668.05A11.448 11.448 0 0 1 8 4c.63 0 1.249.05 1.852.148l.854-.854zM8 6c-1.905 0-3.68.56-5.166 1.526a.48.48 0 0 0-.063.745.525.525 0 0 0 .652.065 8.448 8.448 0 0 1 3.51-1.27L8 6zm2.596 1.404.785-.785c.63.24 1.227.545 1.785.907a.482.482 0 0 1 .063.745.525.525 0 0 1-.652.065 8.462 8.462 0 0 0-1.98-.932zM8 10l.933-.933a6.455 6.455 0 0 1 2.013.637c.285.145.326.524.1.75l-.015.015a.532.532 0 0 1-.611.09A5.478 5.478 0 0 0 8 10zm4.905-4.905.747-.747c.59.3 1.153.645 1.685 1.03a.485.485 0 0 1 .047.737.518.518 0 0 1-.668.05 11.493 11.493 0 0 0-1.811-1.07zM9.02 11.78c.238.14.236.464.04.66l-.707.706a.5.5 0 0 1-.707 0l-.707-.707c-.195-.195-.197-.518.04-.66A1.99 1.99 0 0 1 8 11.5c.374 0 .723.102 1.021.28zm4.355-9.905a.53.53 0 0 1 .75.75l-10.75 10.75a.53.53 0 0 1-.75-.75l10.75-10.75z" />
                </svg> */}
              </div>
              <h4>
                Oops! Something Wrong Happen
                {/* {!isError && currentVideoType == VIDEO_TYPE_SPQ
                  ? 'Please answer the survey to continue'
                  : 'Oops! Something Wrong Happen'} */}
              </h4>
            </div>
          )}

          {/* clr_player_toucharea */}
          <div
            className="clr_player__touchArea"
            onClick={onContainerClick}
          // onTouchEnd={handleMouseMove}
          >
            {/* {isBuffering && <div className="clr_player__loadingCenter"></div>} */}
            {/* play */}
            {!isLoadingFirstTime && (
              <div className={`clr_player_PopUp_Icon ${iconAnimation ? 'active' : ''}`}>
                {playing ? <PauseIcon /> : <PlayIcon />}
              </div>
            )}
          </div>

          {/* backward forward area */}

          <div className="clr_player__backForward">
            {/*  */}
            <div
              className={`clr_player__backForward__in clr_player__backForward--backward ${backwardAnimation ? 'active' : ''
                }`}
              //
              onDoubleClick={onBackwardClick}
            // onDoubleClickCapture={() => alert('hi')}
            >
              <div className="clr_player__backForward__in__animation"></div>
              <div className="clr_player__fastforwardContainer">
                <span className="clr_player__fastforwardContainer__text">- 10</span>
                <div className="clr_player__fastforward">
                  <div className="arrow"></div>
                  <div className="arrow"></div>
                  <div className="arrow"></div>
                </div>
              </div>
            </div>
            {/*  */}

            <div
              className={`clr_player__backForward__in clr_player__backForward--forward ${forwardAnimation ? 'active' : ''
                }`}
              //
              onDoubleClick={onForwardClick}
            >
              <div className="clr_player__backForward__in__animation"></div>
              <div className="clr_player__fastforwardContainer">
                <span className="clr_player__fastforwardContainer__text">+ 10</span>
                <div className="clr_player__fastforward">
                  <div className="arrow"></div>
                  <div className="arrow"></div>
                  <div className="arrow"></div>
                </div>
              </div>
            </div>
          </div>

          {/* {videoHeight > 0 && ( */}
          <InteractiveSpq height={videoHeight} onQuizStart={quizStart} onQuizEnd={quizEnd} />
          {/* )}  */}
          {/* header start */}
          <div className="clr_player__header" ref={ref}>
            <>
              {(title || isLive) && controlsVisibility && <Title title={title} isLive={isLive} />}
            </>

            {/* header right */}
            <div className="clr_player__header__right">
              <div className="clr_player__controllsBar__volume">
                <div
                  className="clr_player__icon cursorPointer"
                  onClick={onMute}
                  title={muted ? 'Mute' : 'Unmute'}
                >
                  {/* mute */}
                  <MuteButton mute={muted} volume={volume} />
                  {/* */}
                </div>
                {/*  volume - slider */}
              </div>

              {/* info icon  */}
              {/* {isInFullScreen && (
                <div className="clr_player__icon " onClick={onInfoBtnClick}>
                  <InfoIcon customClass="info_btn" />
                  {toogleInfo && <div className={toogleInfo ? 'info_up' : 'info_down'}>info</div>}
                </div>
              )} */}
              {title && deeplink && isInFullScreen && (
                <div className="clr_player__icon cursorPointer">
                  <ShareCard data={{ title: title, url: deeplink }} />
                </div>
              )}
            </div>

            {/* tap to unmute */}

            {muted && isLoadingFirstTime && (
              <div
                className="clr_player__tapToUnmute cursorPointer"
                onClick={onTapToUnMute}
                title={muted ? 'Mute' : 'Unmute'}
              >
                <div className="clr_player__tapToUnmute--icon ">
                  <MuteButton mute={muted} volume={volume} />
                </div>
                <span>Tap to Unmute</span>
              </div>
            )}
          </div>
          {/* header end */}

          {/* //  translateY: clr_player__controlls.height */}
          {/* style={controlsVisibility&&{ transform: "translateY(52px)" }} */}
          {/* {console.log("translate", ref.current.style.visibility)} */}
          <div
            className="clr_player__btmSection"
            style={!controlsVisibility ? { transform: 'translateY(52px)' } : {}}
          >
            <div className="clr_player__btmSectionIn">
              {/* floating ads desktop start*/}
              {currentVideoType == VIDEO_TYPE_MAIN && (
                <div className="clr_player__floatingAds cursorPointer">
                  <InVideoBannerCard
                    position={'video-floating'}
                    page_name={'video_archive'}
                    isShown={true}
                    toogleBannerView={onToogleView}
                  />
                </div>
              )}
              {/* floating ads desktop end*/}

              {/* CTA  start*/}
              {currentVideoType == VIDEO_TYPE_ADS &&
                adsData?.length > 0 &&
                adsData[adsIndex]?.items[0]?.CTA && (
                  <CtaCard
                    title={adsData[adsIndex]?.items[0]?.CTA_text}
                    buttonText={adsData[adsIndex]?.items[0]?.CTA_button}
                    onBtnClick={onCtaBtnClick}
                  />
                )}
              {/* CTA  end*/}

              {/* skip start active ---clr_player_skip*/}
              {currentVideoType == VIDEO_TYPE_ADS && skipButton ? (
                <SkipButton
                  seconds={adsData[adsIndex]?.ad_skip_time ?? 0} //
                  playing={playing}
                  onSkipBtnClick={onSkip}
                />
              ) : null}
              {/* skip end*/}

              {/* skip start active ---clr_player_skip*/}
              {incommingCountDown ? (
                <>
                  {/* {console.log(
                    'in comming Count Down #######################################################',
                    incommingCountDown
                  )}
                  <h1>incoming</h1> */}
                  <IncomingCountDown
                    countDown={incommingCountDown}
                    seconds={5} //
                    playing={playing}
                    onCountDownEnd={onCountEnd}
                  />
                </>
              ) : null}
              {/*===============================-********* control start*/}
              {
                <div className="clr_player__controlls" ref={ref}>
                  <div className="clr_player__informationMobile">
                    {/*  */}
                    {isSeeking && (
                      <>
                        <div
                          className={`clr_player__backForward__in clr_player__backForward--backward active`}
                        >
                          <div className="clr_player__fastforwardContainer">
                            <div className="clr_player__fastforward">
                              <div className="arrow"></div>
                              <div className="arrow"></div>
                              <div className="arrow"></div>
                            </div>
                          </div>
                        </div>

                        <h2 className="clr_player__informationMobile__text">
                          Double-tap left or right to skip 10 seconds
                        </h2>
                        <div
                          className={`clr_player__backForward__in clr_player__backForward--forward active`}
                        >
                          <div className="clr_player__fastforwardContainer">
                            <div className="clr_player__fastforward">
                              <div className="arrow"></div>
                              <div className="arrow"></div>
                              <div className="arrow"></div>
                            </div>
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                  <div className="clr_player__progressArea">
                    {/* {currentVideoType != VIDEO_TYPE_ADS && ( */}
                    <div className="range w-100" ms-controller="range-primary">
                      <div className="w-100">
                        {controlsVisibility && (
                          <div className="range-container">
                            <div className="range-track progress">
                              <div
                                className="range-track-bar progress-bar"
                                ms-css-width={`${playedPercentage}%`}
                                style={{ width: `${playedPercentage}%` }}
                              // width={`${playedPercentage}%`}
                              ></div>
                              <div
                                className="range-track-bar progress-bar clr_player__progress-bar_loaded"
                                ms-css-width={`${videoLoadedPercentage}%`}
                                style={{ width: `${videoLoadedPercentage}%` }}
                              // width={`${playedPercentage}%`}
                              ></div>
                            </div>
                            <input
                              // ref={seekBarRef}
                              className="range-control w-100"
                              type="range"
                              value={curentDuration ?? 0}
                              onInput={(e) => {
                                onSeek(e);
                                // onSeekChange();
                              }}
                              onChange={onSeekChange}
                              min={0}
                              // step={1}
                              max={duration}
                            // ms-duplex={played *  100}
                            // ms-on-change="setValue"
                            />
                          </div>
                        )}
                      </div>
                    </div>
                    {/* )} */}
                    {isLive && <span className="clr_player__liveTag active">Live</span>}
                  </div>
                  <div className="clr_player__controllsBar" ref={wrapperRef}>
                    {/* control bar left start*/}

                    {/* control bar left end*/}

                    {/* control bar center start*/}
                    <div className="clr_player__controllsBar__left ">
                      <div className="clr_player__controllsBar__leftBtns">
                        {/* prev */}

                        {playlist?.length > 0 &&
                          playingIndex < playlist?.length &&
                          playingIndex >= 0 && (
                            <div
                              className={`clr_player__icon  ${playingIndex <= 0
                                ? ' clr_player__disabled'
                                : ' clr_player__icon__nextPrev'
                                }`}
                              onClick={onPrevClick}
                              title={'Previous'}
                            >
                              <PrevIcon />
                              {playingIndex > 0 &&
                                playingIndex < playlist?.length &&
                                playlist[playingIndex - 1] && (
                                  <div className="clr_player__dropDwon">
                                    <div className="clr_player__nextThumble cursorPointer">
                                      <div className="clr_player__nextThumble__cover">
                                        <div className="clr_player__nextThumble__Image">
                                          {playlist[playingIndex - 1]?.image && (
                                            <LazyImage
                                              src={playlist[playingIndex - 1].image}
                                              alt="video thumbnail"
                                              width=""
                                              height=""
                                            />
                                          )}
                                          <PauseIcon className="clr_player__nextThumble__playIcon" />
                                        </div>
                                      </div>
                                      <div className="clr_player__nextThumble__content">
                                        <span className="clr_player__nextThumble__tag">
                                          Up Next
                                        </span>
                                        {playlist[playingIndex - 1]?.question && (
                                          <h2 className="clr_player__nextThumble__title textOneLine">
                                            {playlist[playingIndex - 1]?.question}
                                          </h2>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                )}
                            </div>
                          )}
                        {currentVideoType != VIDEO_TYPE_ADS && (
                          <div
                            className="clr_player__icon clr_player__backwardIcon_desk cursorPointer"
                            onClick={onBackwardClick}
                            title={'Back 10 Sec'}
                          >
                            <BackwardIcon />
                          </div>
                        )}

                        {/* play pause */}
                        <div
                          className="clr_player__icon clr_bctrl-playPause cursorPointer"
                          onClick={onPlayPause}
                          title={playing ? 'Play' : 'Pause'}
                        >
                          {playing ? <PlayIcon /> : <PauseIcon />}
                        </div>

                        {currentVideoType != VIDEO_TYPE_ADS && (
                          <div
                            className="clr_player__icon clr_player__forwardIcon_desk cursorPointer"
                            onClick={onForwardClick}
                            title={'Forward 10 Sec'}
                          >
                            <ForwardIcon />
                          </div>
                        )}
                        {/* next */}
                        {playlist?.length > 0 && playingIndex <= playlist?.length && (
                          <div
                            className="clr_player__icon clr_player__icon__nextPrev cursorPointer"
                            onClick={onNextClick}
                            title={'Next'}
                          >
                            <NextIcon />
                            {playlist?.length > 0 &&
                              playingIndex <= playlist?.length &&
                              playlist[playingIndex] && (
                                <div className="clr_player__dropDwon">
                                  <div className="clr_player__nextThumble">
                                    <div className="clr_player__nextThumble__cover">
                                      <div className="clr_player__nextThumble__Image">
                                        {playlist[playingIndex]?.image && (
                                          <LazyImage
                                            src={playlist[playingIndex].image}
                                            alt="video thumbnail"
                                            width=""
                                            height=""
                                          />
                                        )}
                                        <PauseIcon className="clr_player__nextThumble__playIcon" />
                                      </div>
                                    </div>
                                    <div className="clr_player__nextThumble__content">
                                      <span className="clr_player__nextThumble__tag">Up Next</span>
                                      {playlist[playingIndex]?.question && (
                                        <h2 className="clr_player__nextThumble__title line-clamp-1">
                                          {playlist[playingIndex]?.question}
                                        </h2>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              )}
                          </div>
                        )}
                      </div>
                      <div className="clr_player__controllsBar__volume">
                        {/* <div
                          className="clr_player__icon"
                          onClick={onMute}
                          title={muted ? 'Mute' : 'Unmute'}
                        >
                          
                          <MuteButton mute={muted} volume={volume} />
                        </div> */}
                        {/*  volume - slider */}
                        <div
                          className={`volumeSlider cursorPointer`}
                          onMouseLeave={() => {
                            setShowVolume(false);
                          }}
                        >
                          <div
                            className={`iconSize cursorPointer`}
                            onClick={onMute}
                            onMouseEnter={() => {
                              setShowVolume(true);
                            }}
                          >
                            <MuteButton mute={muted} volume={volume} />
                          </div>
                          {showVolume && (
                            <div className={`barHoverBox`}>
                              <div className={`bar cursorPointer`}>
                                <div
                                  className={`barFill`}
                                  style={{ width: `${volume * 100}%` }}
                                ></div>
                                <div
                                  className={`round `}
                                  style={{
                                    left: `calc(${volume * 100}% - ${(1.5 / 100) * (volume * 100)
                                      }rem)`
                                  }}
                                ></div>
                              </div>
                              <input
                                type="range"
                                min="0"
                                max="100"
                                value={volume * 100}
                                onChange={(e) => onVolumeChange(e.target.value)}
                              />
                            </div>
                          )}
                        </div>
                        {/* <div className="clr_volumePanel">
                        <div className="clr_volumeSlider">
                          <div className="clr_volumeSliderRangeBar"></div>
                          <div className="clr_volumeSliderRangeHandle"></div>
                        </div>
                      </div> */}
                      </div>
                      {isLive && !isMobile && (
                        <span className="clr_player__liveTag active">Live</span>
                      )}
                      <div className="clr_player__controllsBar__duration">
                        <span title={'Current Duration'}>
                          {' '}
                          {elapsedTime ? elapsedTime : `00:00`}{' '}
                        </span>
                        <span className="clr_durationDivider">/</span>
                        <span title={'Total Duration'}>
                          {totalDuration ? totalDuration : `00:00`}
                        </span>
                      </div>
                    </div>
                    {/* control bar center end */}
                    {/* control bar right start */}
                    <div className="clr_player__controllsBar__right">
                      {/* settings*/}
                      <div className="clr_player__settingsArea">
                        <div
                          className={`clr_player__icon clr_playerSettings cursorPointer ${isSettingsExpanded ? ' active' : ''
                            }`}
                          onClick={onOpenSettings}
                          title={'Settings'}
                        >
                          <SettingsIcon />
                          {/* <span className="clr_playerTag">HD</span> */}
                        </div>
                        {isSettingsExpanded && (
                          <div className="clr_player__dropDwon">
                            {!openedSetting && (
                              <ul>
                                {/* <li
                                className="clr_player__dropDwon__row"
                                onClick={() => onSelectSettings('quality')}
                              >
                                <h2 className="clr_player__dropDwon--ttl">
                                  <span>Video Quality</span>

                                  <div className="clr_player__dropDwon--Option">
                                    <label>
                                      1080p <span className="clr_player__dropDwon__tag">HD</span>
                                    </label>
                                  </div>
                                </h2>

                                <span className="clr_player__dropDwon__row--arrow">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="16"
                                    height="16"
                                    fill="currentColor"
                                    className="bi bi-chevron-right"
                                    viewBox="0 0 16 16"
                                  >
                                    <path
                                      fillRule="evenodd"
                                      d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"
                                    />
                                  </svg>
                                </span>
                              </li> */}
                                {playbackRate > 0 && (
                                  <li
                                    className="clr_player__dropDwon__row"
                                    onClick={() => onSelectSettings('playback')}
                                  >
                                    <h2 className="clr_player__dropDwon--ttl">
                                      <span>Playback Speed</span>

                                      <div className="clr_player__dropDwon--Option">
                                        <label>{playbackRate}x</label>
                                      </div>
                                    </h2>

                                    <span className="clr_player__dropDwon__row--arrow">
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="16"
                                        height="16"
                                        fill="currentColor"
                                        className="bi bi-chevron-right"
                                        viewBox="0 0 16 16"
                                      >
                                        <path
                                          fillRule="evenodd"
                                          d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"
                                        />
                                      </svg>
                                    </span>
                                  </li>
                                )}
                              </ul>
                            )}
                            {openedSetting == 'quality' && (
                              <div className="clr_player__dropDwon__row--2">
                                <h2
                                  className="clr_player__dropDwon--ttl"
                                  onClick={() => onSelectSettings('playback')}
                                >
                                  Playback Speed
                                </h2>
                                <h2 className="clr_player__dropDwon--ttl">Select Video Quality</h2>
                                <div className="d-flex flex-wrap clr_player__dropDwon--OptionCont">
                                  <div className="clr_player__dropDwon--Options">
                                    {[1080, 720, 360, 240, 'auto'].map((quality) => (
                                      <div className="clr_player__dropDwon--Option">
                                        <input type="radio" name="quality" value={`${quality}p`} />
                                        <label>
                                          {quality}{' '}
                                          <span className="clr_player__dropDwon__tag">p</span>
                                        </label>
                                      </div>
                                    ))}
                                  </div>
                                </div>
                              </div>
                            )}
                            {openedSetting == 'playback' && (
                              <div className="clr_player__dropDwon__row--2">
                                {/* <h2
                                className="clr_player__dropDwon--ttl"
                                onClick={() => onSelectSettings('quality')}
                              >
                                Video Quality
                              </h2> */}
                                <h2 className="clr_player__dropDwon--ttl">Playback Speed</h2>
                                <div className="d-flex flex-wrap clr_player__dropDwon--OptionCont">
                                  {[0.5, 1, 1.5, 2].map((rate) => (
                                    <div className="clr_player__dropDwon--Options">
                                      <div className="clr_player__dropDwon--Option">
                                        <input
                                          type="radio"
                                          name="playbackSpeed"
                                          checked={rate === playbackRate}
                                          value={rate}
                                          onClick={() => {
                                            onPlaybackRateChange(rate);
                                            onSettingsClick();
                                          }}
                                        />
                                        <label>{rate}x</label>
                                      </div>
                                    </div>
                                  ))}
                                </div>
                              </div>
                            )}
                          </div>
                        )}
                      </div>

                      {!isIOS && (
                        <div
                          className="clr_player__icon clr_playerFull_screen cursorPointer"
                          onClick={onToggleFullScreen}
                          title={isInFullScreen ? 'Minimize' : 'Fullscreen'}
                        >
                          {!isInFullScreen ? <FullScreenIcon /> : <MiniizeIcon />}
                        </div>
                      )}
                      <div className="clr_player__icon clr_player__logo  ">
                        <div className="clr_player__logo__in">
                          <ClirnetIconLogo />
                        </div>
                      </div>
                    </div>
                    {/* control bar right end */}
                  </div>
                </div>
              }
              {/*==============================-****** control end*/}
            </div>
          </div>
          {!isError && currentVideoType != VIDEO_TYPE_SPQ && (
            <div className="clr_player__centerIcon" ref={ref}>
              {/* prev */}
              {playlist?.length > 0 && (
                <div
                  className={`clr_player__icon ${playingIndex > 0 && ' clr_player_disabled'}`}
                  onClick={onPrevClick}
                  title={'Previous '}
                >
                  <PrevIcon />
                </div>
              )}
              {/* {currentVideoType != VIDEO_TYPE_ADS && (
                  <div
                    className="clr_player__icon backNDforwardCenter"
                    onClick={onRewind}
                    title={'Previous'}
                  >
                    <BackwardIcon />
                  </div>
                )} */}

              {/* play pause */}
              <div
                className="clr_player__icon clr_bctrl-playPause"
                onClick={onPlayPause}
                title={playing ? 'Play ' : 'Pause'}
              >
                {/* play */}
                {playing ? <PlayIcon /> : <PauseIcon />}
              </div>
              {/* next */}
              {/* {currentVideoType != VIDEO_TYPE_ADS && (
                <div
                  className="clr_player__icon backNDforwardCenter"
                  onClick={onFastForward}
                  title={'Next'}
                >
                  <ForwardIcon />
                </div>
              )} */}
              {playlist?.length > 0 && (
                <div className="clr_player__icon" onClick={onNextClick} title={'Next'}>
                  <NextIcon />
                </div>
              )}
            </div>
          )}
        </>
      </div>
    );
  }
);

Controls.propTypes = {
  onSeek: PropTypes.func,
  onSeekMouseDown: PropTypes.func,
  onSeekMouseUp: PropTypes.func,
  duration: PropTypes.number,
  currentTime: PropTypes.number,
  onRewind: PropTypes.func,
  onPlayPause: PropTypes.func,
  onFastForward: PropTypes.func,
  onVolumeSeekDown: PropTypes.func,
  onChangeDispayFormat: PropTypes.func,
  onPlaybackRateChange: PropTypes.func,
  onToggleFullScreen: PropTypes.func,
  onSkipClick: PropTypes.func,
  onMute: PropTypes.func,
  playing: PropTypes.bool,
  played: PropTypes.number,
  elapsedTime: PropTypes.string,
  totalDuration: PropTypes.string,
  muted: PropTypes.bool,
  playbackRate: PropTypes.number,
  showSkipButton: PropTypes.bool
};
export default memo(Controls);
